module.exports = __webpack_public_path__ + "img/twitter.ce0e5511.svg";